import * as types from "../ActionType";
import axios from "axios";
import { notifyError , notifysuccess } from "../../components/general/Notification";
import { hasExpiritionWithLoad } from "../../components/general/general-component/abstruct-component/useExpirition";
const END_POINT = process.env.REACT_APP_BASE_URL;

const get = (arr,type) => {
    return ({
        type: type,
        payload: arr
    })
}
const add = (type) => {
    return ({
        type: type
    })
}
const delelte = (type) => {
    return ({
        type: type
    })
}
const edit= (type) => {
    return ({
        type: type 
    })
}

export const postEvaluationType = (state,setLoad) => {
    return function (dispatch) {
        setLoad(true)
        
        let token = localStorage.getItem("tokenA");
        axios.post(`${END_POINT}/api/evaluation-types`, state, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            if (res.data.status === "Success") {
                dispatch(add(types.ADD_EVALUATION_TYPE));
                dispatch(loadEvaluationType());
                notifysuccess(res.data.message)
                setLoad(false)
            }
        }).catch((err) => {
            setLoad(false)
            notifyError(err.response.data.message)
        })
    }
}

export const loadEvaluationType = (navigate) => {
    return function (dispatch) {
        let token = localStorage.getItem("tokenA");
        axios.get(`${END_POINT}/api/evaluation-types`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            if (res.data.status == "Success") {
                dispatch(get(res.data.data,types.GET_EVALUATION_TYPE));
            }
        }).catch((err) => {
            notifyError(err.response.data.message)
            hasExpiritionWithLoad(err.response.data.returnedCode,navigate)
        })
    }
}

export const filterEvaluationType = (name,creative_work_type_id, setLoad) => {
    return function (dispatch) {
        let token = localStorage.getItem("tokenA")
        setLoad(true);
        const queryParams = [];
        if (name !== '') queryParams.push(`filters[name]=${name}`);
        if (creative_work_type_id !== null) queryParams.push(`filters[creative_work_type_id]=${creative_work_type_id}`);
        const finalQuery = queryParams.join('&');
        const apiUrl = `${END_POINT}/api/evaluation-types?${finalQuery}`;
        console.log(apiUrl);
        axios.get(apiUrl, {
            headers: {
                "Authorization": `Bearer ${token}`
            }
        }).then((res) => {
            console.log(res);
            setLoad(false);
             dispatch(get(res.data.data,types.GET_EVALUATION_TYPE));
        }).catch((err) => {
            console.log(err);
            setLoad(false);
        });
    };
};

export const deleteEvaluationType= (id,setloadDel,setIsDeleted,setIdDeleted) => {
    return function (dispatch) {
        let token = localStorage.getItem("tokenA");
        setloadDel(true)
        axios.delete(`${END_POINT}/api/evaluation-types/${id}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            if (res.data.status == "Success") {
                dispatch(delelte(types.DELETE_EVALUATION_TYPE));
                notifysuccess(res.data.message)
                //dispatch(loadEvaluationType());
                setIsDeleted('deleted')
                setIdDeleted(id)
                setloadDel(false)
            }
        }).catch((err) => {
            setloadDel(false)
            notifyError(err.response.data.message)
        })
    }
}

export const putEvaluationType = (id,name,constraint,evaluation_type,creative_work_type_id,setLoad) => {
    return function (dispatch) {
        setLoad(true)
        let token = localStorage.getItem("tokenA");
        const formValues = {
            name: name,
            evaluation_type: evaluation_type,
            constraint: constraint,
            creative_work_type_id: creative_work_type_id
        };
        axios.put(`${END_POINT}/api/evaluation-types/${id}`,formValues, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            if (res.data.status === "Success") {
                dispatch(edit(types.EDIT_EVALUATION_TYPEE));
                dispatch(loadEvaluationType());
                notifysuccess(res.data.message)
                setLoad(false)
            }
        }).catch((err) => {
            setLoad(false)
            notifyError(err.response.data.message)
        })
    }
}

export const loadCheckEvaluationByReader = (setEvaluationStatus, setEvaluationStatusType, creativeWorkId) => {
    return () => {
      let token = localStorage.getItem("tokenA");
      console.log(creativeWorkId)
      axios.get(
        `${END_POINT}/api/creative-work/${creativeWorkId}/reader-check`,
        {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        }
      ).then((res) => {
        if (res.data.status === "Success") {
          setEvaluationStatus(res.data.data.evaluationStatus);
          setEvaluationStatusType(res.data.data.evaluationStatusType);
        }
      }).catch((err) => {
        notifyError(err.response.data.message);
      });
    };
};
  
